import React, { useEffect, useRef } from "react";

function Paypal(props) {
  console.log(props, "paypal");
  const paypal = useRef();
  useEffect(() => {
    window.paypal
      .Buttons({
        createOrder: (data, actions, err) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [
              {
                description: "License Fee",
                amount: {
                  currency_code: "USD",
                  value: props.price,
                },
              },
            ],
          });
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture();
          console.log(order, "order");
          props.getPaypalDetail(order);
        },
        onError: (err) => {
          console.log(err);
        },
      })
      .render(paypal.current);
  }, []);
  return (
    <>
      <div ref={paypal}></div>
    </>
  );
}

export default Paypal;
